import * as React from "react";
import "twin.macro";

export default function WhyUs() {
  return (
    <section id="whyus" tw="container mx-auto py-24 px-6">
      <h2 tw="text-secondary text-4xl lg:text-5xl font-medium text-center leading-tight">
        <span tw="text-primary">Drei Gründe</span> warum Sie uns kontaktieren
        sollten <br />
      </h2>
      <div tw="lg:flex lg:mt-12 max-w-xs lg:max-w-none mx-auto">
        <div tw="lg:w-1/3 lg:pr-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            01
          </span>
          <h4 tw="text-xl font-medium mt-4">Zuverlässig</h4>
          <p tw="max-w-xs mt-3">
            Termine halten wir ein – ohne Wenn und Aber. Unsere Kunden aus
            Flensburg und Umgebung vertrauen uns seit Jahren, weil wir tun was
            wir versprechen. Punkt.
          </p>
        </div>
        <div tw="lg:w-1/3 lg:px-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            02
          </span>
          <h4 tw="text-xl font-medium mt-4">Rundum-Service</h4>
          <p tw="max-w-xs mt-3">
            Vom Heckenschnitt über Pflasterarbeiten bis zur ganzjährigen
            Gartenpflege – ein Ansprechpartner für alles. Kein Koordinieren
            mehrerer Firmen, kein Stress.
          </p>
        </div>
        <div tw="lg:w-1/3 lg:pl-6">
          <span tw="text-8xl block max-w-xs text-right -mb-12 text-primary">
            03
          </span>
          <h4 tw="text-xl font-medium mt-4">Regional verwurzelt</h4>
          <p tw="max-w-xs mt-3">
            Wir sind direkt vor Ort in Flensburg, Schleswig und Glücksburg.
            Kurze Wege, schnelle Reaktion, persönlicher Kontakt – kein Call
            Center, sondern echte Menschen.
          </p>
        </div>
      </div>
    </section>
  );
}
